// This function allow to reference async chunks
__webpack_require__.u = function(chunkId) {
	// return url for filenames based on template
	return "" + {"125":"component---src-pages-404-js","293":"component---src-pages-index-js"}[chunkId] + "-" + {"125":"34aa98a2f49e437f1216","293":"4e34de93992e3ffbb06b"}[chunkId] + ".js";
};